import React, { Component, useEffect } from 'react';
import './HostGameView.scss';

export default class SelectingTeam extends Component {
    constructor(props) {
        super(props);
        this.state = {
            room: props.room,
            players: props.players,

        }
    }

    render() {
        return (
            <div className="host-selecting-team-container">
               
            </div>
        )
    }
}

